import React from 'react';

// جزء بسيط يظهر أثناء تحميل أي صفحة Lazy
const SectionLoader: React.FC = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
        <div style={{ width: 40, height: 40, border: '4px solid #3b82f6', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
);

export default SectionLoader;
